import React from 'react';

import {
  isDesktopApp,
  isDesktopOffline,
} from '@/api/desktopSync';
import useDesktopDeviceStatus from '@/hooks/useDesktopDeviceStatus';


export default function DesktopAuthorizationNotice() {
  const status = useDesktopDeviceStatus();
  const offline = isDesktopOffline();

  if (!isDesktopApp() || offline || !status?.needsRenewal) return null;

  return (
    <div
      className="px-3 py-2 bg-amber-700 text-white text-xs font-medium flex-shrink-0"
      data-testid="desktop-authorization-notice"
    >
      This computer&apos;s offline authorization needs to be renewed. Online work is still available. Please contact an administrator.
    </div>
  );
}
